import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router';
import BlitzAPI from '../../api/BlitzAPI';
import { SOURCE_TABLE_TYPE_OPTIONS } from '../form/constants';

const cellEditProp = {
  mode: 'dbclick',
  blurToSave: true,
};

function sourceDataFormat(cell) {
  return (
    <Link to={`/sources/${cell}`}>
      <div>
        {cell}
      </div>
    </Link>
  );
}

export default class SourceListTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
    this.onCellEdit = this.onCellEdit.bind(this);
  }

  componentDidMount() {
    BlitzAPI.getSources().then(
      (resp) => {
        return this.setState({ data: resp.data.data });
      },
    );
  }

  onCellEdit(row, fieldName, value) {
    const { data } = this.state;
    let rowIndex;
    const targetRow = data.find(
      (currentRow, index) => {
        if (currentRow.id === row.id) {
          rowIndex = index;
          return true;
        }
        return false;
      },
    );

    if (targetRow && targetRow[fieldName] !== value) {
      targetRow[fieldName] = value;
      data[rowIndex] = targetRow;
      const sourceParams = {};
      sourceParams[fieldName] = value;
      BlitzAPI.patchSource(row.id, { source: sourceParams }).then(
        response => console.log(response),
      );
      this.setState({ data });
    }
  }

  render() {
    return (
      this.state.data ?
        <BootstrapTable
          data={this.state.data}
          remote striped hover
          cellEdit={cellEditProp}
          options={{ onCellEdit: this.onCellEdit }}
        >
          <TableHeaderColumn isKey dataField="id" dataFormat={sourceDataFormat}>Source ID</TableHeaderColumn>
          <TableHeaderColumn dataField="name">Name</TableHeaderColumn>
          <TableHeaderColumn
            dataField="type"
            editable={{ type: 'select', options: { values: SOURCE_TABLE_TYPE_OPTIONS } }}
          >Type</TableHeaderColumn>
          <TableHeaderColumn dataField="url">URL</TableHeaderColumn>
        </BootstrapTable> : <div><h1>Loading</h1></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/source/SourceListTable.js